import { Component } from '@angular/core';
import { SecurityPermissionName } from '@app/core/models/permission';
import { SubNavBaseComponent } from '@app/menu/components/sub-nav-base-component';

@Component({
  selector: 'portal-enterprise-journal-sub-nav',
  templateUrl: './enterprise-journal-sub-nav.component.html',
  standalone: false,
})
export class EnterpriseJournalSubNavComponent extends SubNavBaseComponent {
  Permission = SecurityPermissionName;
}
